import { isFedRamp } from '@atlassian/atl-context';
import { nextBestTaskFeatureResource } from '@atlassian/jira-router-resources-next-best-task/src/services/index.tsx';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';

export const conditionalBoardNBTOptInResource = resourceWithCondition(
	() => !isFedRamp(),
	nextBestTaskFeatureResource,
);
